import React, { useState } from 'react';

const FAQS = [
  {
    q: 'Is this information officially guaranteed?',
    a: 'No. This tool is for informational purposes only. While we aim for accuracy, visa policies change overnight. Always confirm with the official consulate website.',
  },
  {
    q: 'What is an eVisa?',
    a: "An eVisa is an official document issued online by a government's immigration department that allows you to enter and travel within that country.",
  },
  {
    q: 'Do I need travel insurance?',
    a: 'Even if not strictly required for a visa, travel insurance is highly recommended for all international trips to cover medical emergencies.',
  },
  {
    q: 'How current is the data?',
    a: 'Results are generated using AI with knowledge of current policies and supplemented by live data where available. Responses are cached for 24 hours. Always verify with official sources before travel.',
  },
];

const FaqSection: React.FC = () => {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="bg-slate-50 border-t border-slate-100 no-print">
      <div className="max-w-5xl mx-auto px-6 py-16">
        <div className="max-w-2xl mx-auto">

          <div className="text-center mb-10">
            <h2 className="text-2xl font-black text-slate-900 mb-2">Common questions</h2>
            <p className="text-sm text-slate-500">Everything you need to know about using Visa Hub</p>
          </div>

          <div className="space-y-2">
            {FAQS.map((faq, i) => (
              <div key={i} className="bg-white border border-slate-200 rounded-xl overflow-hidden">
                <button
                  type="button"
                  className="w-full flex items-center justify-between px-5 py-4 text-left"
                  onClick={() => setOpenIdx(openIdx === i ? null : i)}
                >
                  <span className="font-semibold text-slate-900 text-sm pr-4">{faq.q}</span>
                  <svg
                    className={`w-4 h-4 text-slate-400 flex-shrink-0 transition-transform ${openIdx === i ? 'rotate-180' : ''}`}
                    fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                {openIdx === i && (
                  <div className="px-5 pb-4 text-sm text-slate-500 leading-relaxed border-t border-slate-100 pt-3">
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="mt-10 flex items-center justify-center gap-6 text-xs text-slate-400">
            <div className="flex items-center gap-1.5">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-400" />
              AI-powered
            </div>
            <div className="flex items-center gap-1.5">
              <span className="w-1.5 h-1.5 rounded-full bg-blue-400" />
              200+ countries
            </div>
            <div className="flex items-center gap-1.5">
              <span className="w-1.5 h-1.5 rounded-full bg-violet-400" />
              Free to use
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default FaqSection;
